import { Popover as AntPopover } from "antd";
import React from "react";

const Popover = ({ ...props }) => {
  return (
    <AntPopover
      arrow={false}
      placement="bottomRight"
      overlayInnerStyle={{
        boxShadow: "none",
        borderRadius: "2rem",
        padding: "2rem 2.5rem 2.7rem",
      }}
      {...props}
    />
  );
};

export default Popover;
